// ShowcaseAccordion.js
class ShowcaseAccordion {
    constructor() {
        this.accordionTriggers = document.querySelectorAll('.showcase-accordion');
        // toggleAccordion 메서드의 this 바인딩을 명시적으로 클래스 인스턴스에 고정합니다.
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.initEvents();
    }

    initEvents() {
        this.accordionTriggers.forEach(trigger => {
            trigger.addEventListener('click', this.toggleAccordion);
        });
    }

    toggleAccordion(event) {
        const trigger = event.currentTarget;
        const content = trigger.nextElementSibling;

        if (content.classList.contains('active')) {
            content.classList.remove('active');
            return;
        }

        document.querySelectorAll('.is-layout-flow.wp-block-column').forEach(el => {
            el.classList.remove('active');
        });

        content.classList.add('active');
    }

    updateEvents() {
        this.accordionTriggers = document.querySelectorAll('.showcase-accordion');
        this.initEvents();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.showcaseAccordion = new ShowcaseAccordion();
});


export default ShowcaseAccordion;


